import moment from 'moment'
import { APIFactory } from '../api/api.factory'

const MealAPI = APIFactory.get('meals');
const ExpenseReportAPI = APIFactory.get('expenseReport')

const setIsExceptionSatisifed = function (m,attachments) {

    //check if breakfast exceptions satisfied
    if (m.breakfastExceptions) {
        for (let i = 0; i < m.breakfastExceptions.length; i++) {
            let breakfastException = m.breakfastExceptions[i];
            if (breakfastException.expenseExceptionTypeId == 4) {               
                breakfastException.isSatisfied = attachments.length > 0;
            }
            else if (breakfastException.expenseExceptionTypeId == 5) {
                if (breakfastException.responseValue.length >= 1) {
                    breakfastException.isSatisfied = true;
                }
                else {
                    breakfastException.isSatisfied = false;
                }
            }
            else {
                breakfastException.isSatisfied = false;
            }
        }
        
    }

    //check if lunch exceptions satisfied
    if (m.lunchExceptions) {
        for (let i = 0; i < m.lunchExceptions.length; i++) {
            let lunchException = m.lunchExceptions[i];
            if (lunchException.expenseExceptionTypeId == 4) {
                    lunchException.isSatisfied = attachments.length > 0;
            }
            else if (lunchException.expenseExceptionTypeId == 5) {
                if (lunchException.responseValue.length >= 1) {
                    lunchException.isSatisfied = true;
                }
                else {
                    lunchException.isSatisfied = false;
                }
            }
            else {
                lunchException.isSatisfied = false;
            }
        }
        
    }

    //check if dinner exceptions satisfied
    if (m.dinnerExceptions) {
        for (let i = 0; i < m.dinnerExceptions.length; i++) {
            let dinnerException = m.dinnerExceptions[i];
            if (dinnerException.expenseExceptionTypeId == 4) {
                dinnerException.isSatisfied = attachments.length > 0;
            }
            else if (dinnerException.expenseExceptionTypeId == 5) {
                if (dinnerException.responseValue.length >= 1) {
                    dinnerException.isSatisfied = true;
                }
                else {
                    dinnerException.isSatisfied = false;
                }
            }
            else {
                dinnerException.isSatisfied = false;
            }
        }
        
    }

    //check if incidentals exceptions satisfied
    if (m.incidentalsExceptions) {
        for (let i = 0; i < m.incidentalsExceptions.length; i++) {
            let incidentalsException = m.incidentalsExceptions[i];
            if (incidentalsException.expenseExceptionTypeId == 4) {
                incidentalsException.isSatisfied = attachments.length > 0;
            }
            else if (incidentalsException.expenseExceptionTypeId == 5) {
                if (incidentalsException.responseValue.length >= 1) {
                    incidentalsException.isSatisfied = true;
                }
                else {
                    incidentalsException.isSatisfied = false;
                }
            }
            else {
                incidentalsException.isSatisfied = false;
            }
        }
    }
}



export default {
    async deleteException(exceptionID) {
        const { data } = await MealAPI.deleteException(exceptionID);
        return data;
    },
    async getMeals(erID) {
        console.log('mealService.getMeals')
        const { data } = await MealAPI.get(erID);

        return data;
    },

    async saveMeals(request) {
        console.log('mealService.saveMeals')
        const { data } = await MealAPI.save(request);

        return data;
    },
    async deleteMeal(erID) {
        console.log('mealService.deleteMeal')
        const { data } = await ExpenseReportAPI.delete(erID);

        return data;
    },
    async getMealsLocationSummary(erID) {
        console.log('mealService.getMealLocationSummary')
        const { data } = await ExpenseReportAPI.getMealsLocationSummary(erID);

        return data;
    },
    async getReferenceDates(erID) {
        console.log('mealService.getReferenceDates')
        const { data } = await ExpenseReportAPI.getReferenceDates(erID);

        return data;
    },
    createSaveRequest(expenseReportID, meals, supportingRemark, attachments) {
        let listOfMeals = [];
        let mealRequest = {
            expenseReportId: expenseReportID,
            mealDates: listOfMeals,
            supportingRemark: supportingRemark
        };
        let mealsAttached = false;

        meals.forEach(m => {
            setIsExceptionSatisifed(m, attachments);
            if (!mealsAttached && attachments.length) {
                if (m.breakfastExceptions.length) {
                    m.breakfastExceptions[0].attachments = attachments;
                    mealsAttached = true;
                }
                else if (m.lunchExceptions.length) {
                    m.lunchExceptions[0].attachments = attachments;
                    mealsAttached = true;
                }
                else if (m.dinnerExceptions.length) {
                    m.dinnerExceptions[0].attachments = attachments;
                    mealsAttached = true;
                }
                else if (m.incidentalsExceptions.length) {
                    m.incidentalsExceptions[0].attachments = attachments;
                    mealsAttached = true;
                }
            }
            listOfMeals.push(
                {
                    "expenseReportId": expenseReportID,
                    "date": m.date,
                    "id": m.dayDateID,
                    "meals": [
                        {
                            "mealTypeId": 1,
                            "amount": m.breakfast,
                            "adjustment": m.breakfastAdjusted,
                            "id": m.breakfastID,
                            "exceptions": m.breakfastExceptions ? m.breakfastExceptions : []
                        },
                        {
                            "mealTypeId": 2,
                            "amount": m.lunch,
                            "adjustment": m.lunchAdjusted,
                            "id": m.lunchID,
                            "exceptions": m.lunchExceptions ? m.lunchExceptions : []
                        },
                        {
                            "mealTypeId": 3,
                            "amount": m.dinner,
                            "adjustment": m.dinnerAdjusted,
                            "id": m.dinnerID,
                            "exceptions": m.dinnerExceptions ? m.dinnerExceptions : []
                        },
                        {
                            "mealTypeId": 4,
                            "amount": m.incidentals,
                            "adjustment": m.incidentalsAdjusted,
                            "id": m.incidentalsID,
                            "exceptions": m.incidentalsExceptions ? m.incidentalsExceptions : []
                        }
                    ],
                },
            )
        })
        return mealRequest;
    }
}